import { useEffect } from 'react';
import Broadcast from 'services/BroadcastChannel';

export default () => {
  useEffect(() => {
    Broadcast.channelSwitchUser().initListener();
  }, []);
};
